import {
  i
} from "./chunk.775UL347.js";

// src/components/jb-market-display/jb-market-display.css.ts
var jb_market_display_css_default = i`span{font-family:var(--theme-font-light-family, VerlagSSmforBaerVar, Tahoma, sans-serif);font-style:normal;font-weight:var(--theme-font-light-weight, 300)}span{font-size:var(--theme-typo-body-sm-desktop-fontsize, 0.813rem);font-weight:var(--theme-typo-body-sm-fontweight, var(--theme-font-light-weight, 300));line-height:var(--theme-typo-body-sm-desktop-lineheight, 1.25rem)}.sr-only{block-size:1px;border:0;clip:rect(0, 0, 0, 0);inline-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute}div{align-items:center;display:flex}span{color:rgb(var(--theme-color-royal-blue)/var(--theme-opacity-40));line-height:unset}.long{display:none}@media(min-width: 600px){.short{display:none}.long{display:inline-block}}`;

export {
  jb_market_display_css_default
};
